import actionCreator from '../../shared/decorators/actionCreator';
import { REDUX_NAMESPACE } from '../constants';

const ACTION_CREATORS = {
  @actionCreator(REDUX_NAMESPACE)
  pause() {},

  @actionCreator(REDUX_NAMESPACE)
  play() {},

  @actionCreator(REDUX_NAMESPACE)
  playFromFrame(frameNumber) {
    return {
      frameNumber,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  scrubToFrame(frame) {
    return {
      frame,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  scrubToNextFrame() {},

  @actionCreator(REDUX_NAMESPACE)
  scrubToPreviousFrame() {},

  @actionCreator(REDUX_NAMESPACE)
  setAudible(audible = true) {
    return { audible };
  },

  @actionCreator(REDUX_NAMESPACE)
  toggleAudible() {},

  @actionCreator(REDUX_NAMESPACE)
  cycleSpeed() {},

  @actionCreator(REDUX_NAMESPACE)
  setSpeed(speed) {
    return { speed };
  },

  @actionCreator(REDUX_NAMESPACE)
  startBuffering() {},

  @actionCreator(REDUX_NAMESPACE)
  stopBuffering() {},
};

export default ACTION_CREATORS;
